import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import * as appGlobals from "./app.globals";
import { Amplify, API, graphqlOperation } from "aws-amplify";
import {
  listSocials,
  listSummaries,
  listExperiences,
  listSkills,
  listWorkflows,
  listProjects,
  listRoundups,
  listEducations,
} from "../graphql/custom-queries";
import * as awsconfig from "../aws-exports";
import { Entity } from "./models/entity";

Amplify.configure(awsconfig.default);

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  public constructor(private titleService: Title) {}

  socials: Entity[];
  summaries: Entity[];
  experiences: Entity[];
  skills: Entity[];
  workflows: Entity[];
  projects: Entity[];
  educations: Entity[];
  roundups: Entity[];

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  async ngOnInit() {
    let socialResponse = await API.graphql(graphqlOperation(listSocials));
    this.socials = <Entity[]>(socialResponse as any).data.listEntitys.items;
    let summaryResponse = await API.graphql(graphqlOperation(listSummaries));
    this.summaries = <Entity[]>(summaryResponse as any).data.listEntitys.items;
    let skillResponse = await API.graphql(graphqlOperation(listSkills));
    this.skills = <Entity[]>(skillResponse as any).data.listEntitys.items;
    let workflowResponse = await API.graphql(graphqlOperation(listWorkflows));
    this.workflows = <Entity[]>(workflowResponse as any).data.listEntitys.items;
    let projectResponse = await API.graphql(graphqlOperation(listProjects));
    this.projects = <Entity[]>(projectResponse as any).data.listEntitys.items;
    let roundupResponse = await API.graphql(graphqlOperation(listRoundups));
    this.roundups = <Entity[]>(roundupResponse as any).data.listEntitys.items;
    let experienceResponse = await API.graphql(
      graphqlOperation(listExperiences)
    );
    this.experiences = <Entity[]>(
      (experienceResponse as any).data.entitiesByEndDate.items
    );
    let educationResponse = await API.graphql(graphqlOperation(listEducations));
    this.educations = <Entity[]>(
      (educationResponse as any).data.entitiesByEndDate.items
    );
    this.setTitle("About " + appGlobals.title);
  }
}
